import React from "react";

import Select from "react-select";

import { ALERT_TYPES, MONITOR_VIEW_MODES } from "containers/Monitoring/reducer";
import FrontierSliders from "containers/FrontierSliders/FrontierSliders";

import styles from "./style.module.css";

export default class MonitoringFeedback extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subgroupSelect: {
        value: "All",
        label: "All"
      }
    };
  }
  render() {
    const {
      project,
      modelGroups,
      segmentId,
      warnings,
      adjustAssumptions,
      monitoringData,
      latestData,
      latestScenario,
      scenarioIndex,
      isContinuous,
      monitorViewMode,
      userFeedback,
      deleteUserFeedback,
      selectedDataset
    } = this.props;

    const { subgroupSelect } = this.state;

    const subgroupOptions =
      modelGroups && modelGroups.drilldownValues
        ? modelGroups.drilldownValues.map((d, i) =>
            i == 0 ? { label: "All", value: "All" } : { label: d.value, value: d.value }
          )
        : [];

    return (
      <div className={styles.monitoringFeedback}>
        <div className={styles.mHeader}>{"End User Preferences"}</div>
        <div className={styles.mFeedbackLegend}>
          <div className={styles.mLegendItem}>
            <div className={styles.mCurrentIcon} style={{ background: "#7E69D7" }} />
            {"Org Default Model"}
          </div>
          <div className={styles.mLegendItem}>
            <div className={styles.mCurrentIcon} />
            {"User Selected Model"}
          </div>
          <div className={styles.mLegendItem}>
            <div className={styles.mLegendIcon} style={{ background: "#5BCF74" }} />
            {"Thumbs Up Feedback"}
          </div>
          <div className={styles.mLegendItem}>
            <div className={styles.mLegendIcon} style={{ background: "rgb(248, 205, 126)" }} />
            {"Thumbs Down Feedback"}
          </div>
          <div className={styles.mLegendItem}>
            <div>{"Show Subgroup"}</div>
            <div className={styles.selectHolder}>
              <Select
                options={subgroupOptions}
                value={subgroupSelect}
                onChange={(val) => this.setState({ subgroupSelect: val })}
              />
            </div>
          </div>
        </div>
        <div className={styles.mTableHeader}>
          <div className={styles.mHeaderOne}>{"User"}</div>
          <div className={styles.mHeaderTwo} style={{ marginLeft: "10px" }}>
            {"Preference"}
          </div>
        </div>
        <div className={styles.mTable}>
          {project && project.roles ? (
            project.roles.map((r, i) => (
              <div className={styles.mTableRow} key={i} style={i === 0 ? { borderTop: "none" } : {}}>
                <div className={styles.mHeaderOne}>{r.role_user.fullname}</div>
                <div className={styles.mHeaderTwo}>
                  <FrontierSliders
                    id={project ? project.id : undefined}
                    isUserFeedback
                    username={r.role_user.fullname}
                    subgroup={subgroupSelect && subgroupSelect.value !== "All" ? subgroupSelect.value : undefined}
                  />
                </div>
              </div>
            ))
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }
}
